"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEditableTotalQuery = exports.getWritableProductPropertyNames = exports.getWritableProductProperties = exports.getCanModifyProductLibrary = exports.getProductsQuery = void 0;

var _reselect = require("reselect");

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var _selectors = require("settings-ui-sdk/Auth/selectors");

var _selectors2 = require("settings-ui-sdk/Properties/selectors");

var _ProductsFilters = require("crm_data/products/ProductsFilters");

var getProductsQuery = (0, _getIn.default)(['modules', 'sales', 'products', 'query']);
exports.getProductsQuery = getProductsQuery;
var getUngatedForProductLibrary = (0, _reselect.createSelector)([_selectors.getUserGates], function (gates) {
  return ['SalesPro:Grandparenting', 'SalesPro:2017'].some(function (gate) {
    return gates.indexOf(gate) > -1;
  });
});
var getHasProductLibraryWrite = (0, _reselect.createSelector)([_selectors.getUserScopes], function (scopes) {
  return scopes.indexOf('inbounddb-product-library-write') > -1;
});
var getCanModifyProductLibrary = (0, _reselect.createSelector)([getUngatedForProductLibrary, getHasProductLibraryWrite], function (ungatedForProductLibrary, hasProductLibraryWrite) {
  return ungatedForProductLibrary && hasProductLibraryWrite;
});
exports.getCanModifyProductLibrary = getCanModifyProductLibrary;
var LINE_ITEM_ONLY_PROPERTIES = ['discount', 'hs_discount_percentage', 'tax', 'hs_recurring_billing_start_date'];
var getWritableProductProperties = (0, _reselect.createSelector)([_selectors2.getProductProperties], function (properties) {
  return properties.toSet().filterNot(function (property) {
    return property.readOnlyValue || LINE_ITEM_ONLY_PROPERTIES.includes(property.name);
  });
});
exports.getWritableProductProperties = getWritableProductProperties;
var getWritableProductPropertyNames = (0, _reselect.createSelector)([getWritableProductProperties], function (properties) {
  return properties.map(function (property) {
    return property.name;
  });
});
exports.getWritableProductPropertyNames = getWritableProductPropertyNames;
var getEditableTotalQuery = (0, _reselect.createSelector)([_selectors2.isEcommSetUp, getProductsQuery], function (ecommSetUp, query) {
  var baseQuery = (0, _ProductsFilters.removeFilters)(query.set('count', 0), _ProductsFilters.indexPageFilter);
  return ecommSetUp ? (0, _ProductsFilters.addUniqueFilters)(baseQuery, _ProductsFilters.hubSpotProductsFilter) : baseQuery;
});
exports.getEditableTotalQuery = getEditableTotalQuery;